import TokenBlot from "./TokenBlot";

const insertToken = (quill, tokenData) => {
  let index = (quill.getSelection() || {}).index;
  index = typeof index === "number" ? index : quill.getLength();

  quill.insertEmbed(index, TokenBlot.blotName, tokenData);
  quill.setSelection(index + 1, 0);
};

export default insertToken;
